import { render, staticRenderFns } from "./ModalDisableEnable2Fa.vue?vue&type=template&id=5f25c971&scoped=true&"
import script from "./ModalDisableEnable2Fa.vue?vue&type=script&lang=js&"
export * from "./ModalDisableEnable2Fa.vue?vue&type=script&lang=js&"
import style0 from "./ModalDisableEnable2Fa.vue?vue&type=style&index=0&id=5f25c971&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f25c971",
  null
  
)

export default component.exports